module.exports = __webpack_public_path__ + "static/img/200257.f1aa51f0.png";